import Echarts from "echarts";
import { numConvert } from "../../../../method";

const color = ['#4c9bf2', '#4AC18E', '#D9534F', '#67A8E4'];

export default function (data, { key, name }) {

    const listName = ['Today 今日实际', 'Last Year 去年当日'];
    const myChart = Echarts.init(document.getElementById('chart-element'));
    // 做下去重处理，以防重复
    data = data.reduce((a, b) => {
        if (!a.find(item => item.month == b.month && item.day == b.day)) a.push(b);
        return a;
    }, []);
    data.sort((a, b) => a.month - b.month || a.day - b.day);
    key = key.split(',');
    const dataX = data.map(x => `${x.month}-${x.day}`);
    const isPercent = name.includes('%');
    const option = {
        color,
        backgroundColor: "#fff",
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data: listName,
            bottom: "5%"
        },
        grid: {
            left: '10%',
            right: '10%',
            bottom: '20%',
        },

        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: dataX,

        },
        yAxis: {
            type: 'value',
            axisLine: {
                show: false
            }
        },
        series: key.map((x, i) => {
            return {
                name: listName[i],
                type: 'line',
                smooth: true,
                data: data.map(v => isPercent ? numConvert(v[x] * 100).toFixed(1) : numConvert(v[x]).toFixed(2)),

            }
        })
    };

    myChart.setOption(option);

}


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/daily/1.2/chart.js